import {Form, Formik} from 'formik'
import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import TextInput from '../../widgets/components/Input/TextInput'
import * as Yup from 'yup'
import {CustomButton} from '../../widgets/components/UI/CustomButton'
import {
  addBoardAdvisors,
  getSingleCompanyBoardAdvisors,
  updateBoardAdvisors,
} from '../core/_requests'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import {FileUpload} from '../../widgets/components/FileUpload'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {membersType} from '../core/_constants'
import {Spinner} from '../../widgets/components/General/Spinner'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import { removeNullFields } from '../../../core/_util'

export const AddBoardAdvisorModal = ({
  showBoardAdvisorsModal,
  setShowBoardAdvisorsModal,
  companyBoardAdvisorsId,
  updateModalStatus,
  getAllCompanyBoardAdvisors,
  memberType,
  setImgName,
  imgName,
}: {
  showBoardAdvisorsModal: boolean
  setShowBoardAdvisorsModal: Dispatch<SetStateAction<boolean>>
  companyBoardAdvisorsId: number | undefined
  updateModalStatus: boolean
  getAllCompanyBoardAdvisors: any
  memberType: string
  setImgName: any
  imgName: any
}) => {
  const {formatMessage} = useIntl()
  const [loading, setLoading] = useState(false)
  const {companyId, currentUser} = useAuth()
  const [singleBoardAdvisorsData, setSingleBoardAdvisorsData] = useState<any>()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [singleBoardAdvisorDataLoading, setSingleBoardAdvisorDataLoading] = useState(false)
  const initialValues = {
    name: '',
    designation: '',
    joining_month: '',
    fileId: null,
  }

  const boardAdvisorsSchema = Yup.object().shape({
    name: Yup.string()
      .min(1, formatMessage({id: 'Minimum 1 character is required'}))
      .max(50, formatMessage({id: 'Maximum 50 characters'}))
      .required(formatMessage({id: 'Name is required'}))
      .nullable(),
    designation: Yup.string().required(formatMessage({id: 'Designation is required'})),
    joining_month: Yup.string()
      .required(formatMessage({id: 'Joining Date is required'}))
      .nullable(),
    fileId: Yup.string()
      .required(formatMessage({id: 'File is required'}))
      .nullable(),
  })

  const onSubmit = async (values: any) => {
    try {
      setLoading(true)
      if (memberType === membersType.ADVISOR) {
        values = {...values, type: 'ADVISOR'}
      } else {
        values = {...values, type: 'BOARDMEMBER'}
      }
      if (updateModalStatus && companyBoardAdvisorsId) {
        const {
          data: {success, errors},
        } = await updateBoardAdvisors(values, companyBoardAdvisorsId)
        if (success) {
          setImgName('')
          getAllCompanyBoardAdvisors()
          getSingleBoardAdvisor(companyBoardAdvisorsId)
          setLoading(false)
          setShowBoardAdvisorsModal(false)
          toast.success(
            formatMessage({
              id:
                memberType === membersType.ADVISOR
                  ? 'Company Advisor updated successfully'
                  : 'Company member updated successfully',
            })
          )
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardAdvisorsSuccessful,
              action: 'normal',
              metadata: removeNullFields({
                company_board_advisors_id: companyBoardAdvisorsId,
                company_board_advisors_name: values?.name,
                company_board_advisors_designation: values?.designation,
                company_board_advisors_joining_month: values?.joining_month,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              }),
            },
          })
        } else {
          setLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardAdvisorsFailed,
              action: 'normal',
              metadata: removeNullFields({
                company_board_advisors_id: companyBoardAdvisorsId,
                company_board_advisors_name: values?.name,
                company_board_advisors_designation: values?.designation,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_board_advisors_joining_month: values?.joining_month,
                error: errors[0],
              }),
            },
          })
        }
      } else {
        if (companyId) {
          const {
            data: {success, errors},
          } = await addBoardAdvisors(values, companyId)
          if (success) {
            setImgName('')
            getAllCompanyBoardAdvisors()
            setLoading(false)
            setShowBoardAdvisorsModal(false)
            toast.success(
              formatMessage({
                id:
                  memberType === membersType.ADVISOR
                    ? 'Company Advisor Added successfully'
                    : 'Company member Added successfully',
              })
            )
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.AddBoardAdvisorsSuccessful,
                action: 'normal',
                metadata: removeNullFields({
                  company_board_advisors_name: values?.name,
                  company_board_advisors_designation: values?.designation,
                  company_board_advisors_joining_month: values?.joining_month,
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                }),
              },
            })
          } else {
            setLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.AddBoardAdvisorsFailed,
                action: 'normal',
                metadata: removeNullFields({
                  company_board_advisors_name: values?.name,
                  company_board_advisors_designation: values?.designation,
                  company_board_advisors_joining_month: values?.joining_month,
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  error: errors[0],
                }),
              },
            })
          }
        }
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const getSingleBoardAdvisor = async (companyBoardAdvisorsId: number) => {
    try {
      setSingleBoardAdvisorDataLoading(true)
      const {
        data: {data, success, errors},
      } = await getSingleCompanyBoardAdvisors(companyBoardAdvisorsId)
      if (success) {
        setSingleBoardAdvisorsData(data)
        setSingleBoardAdvisorDataLoading(false)
        if (data.file?.fileId !== null) {
          setImgName(data.file?.name)
        } else {
          setImgName(undefined)
        }
      } else {
        setSingleBoardAdvisorDataLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      setSingleBoardAdvisorDataLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    if (companyBoardAdvisorsId) {
      getSingleBoardAdvisor(companyBoardAdvisorsId)
    }
  }, [companyBoardAdvisorsId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }
  return (
    <Modal
      size='lg'
      show={showBoardAdvisorsModal}
      onHide={() => setShowBoardAdvisorsModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      {singleBoardAdvisorDataLoading ? <Spinner /> : null}
      <Formik
        initialValues={initialValues}
        validationSchema={boardAdvisorsSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          if (updateModalStatus && singleBoardAdvisorsData) {
            formik.initialValues.name = singleBoardAdvisorsData?.name
            formik.initialValues.designation = singleBoardAdvisorsData?.designation
            formik.initialValues.joining_month =
              singleBoardAdvisorsData?.joining_month.split('T')[0]
            formik.initialValues.fileId = singleBoardAdvisorsData?.fileId
          } else {
            formik.initialValues.name = ''
            formik.initialValues.designation = ''
            formik.initialValues.joining_month = ''
            formik.initialValues.fileId = null
          }
          return (
            <Form>
              <Modal.Body>
                <div className='d-flex justify-content-between m-5'>
                  <h2>
                    {updateModalStatus
                      ? formatMessage({
                          id:
                            memberType === membersType.ADVISOR
                              ? 'Edit Board Advisor'
                              : 'Edit Board Member',
                        })
                      : formatMessage({
                          id:
                            memberType === membersType.ADVISOR
                              ? 'Add Board Advisor'
                              : 'Add Board Member',
                        })}
                  </h2>
                  <img
                    src={toAbsoluteUrl('/media/icons/investor/Cancel.svg')}
                    alt='cancel'
                    className='cursor-pointer'
                    onClick={() => {
                      setShowBoardAdvisorsModal(false)
                      setImgName('')
                    }}
                  />
                </div>
                <div className='mt-8 m-5'>
                  <div className='d-flex flex-column flex-md-row col-12'>
                    <div className='col-md-5 col-10'>
                      <p>{formatMessage({id: 'Profile Picture'})}</p>
                      <div
                        className={`people-profile-card position-relative d-flex justify-content-center m-md-0 m-auto ${
                          imgName ? 'card-name' : 'p-0'
                        }`}
                        onClick={handleOpen}
                      >
                        <DisplayImage imgName={imgName} alt='profile' width='100%' />
                        <div className='pencil-container'>
                          <img
                            src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                            alt=''
                            className='cursor-pointer'
                          />
                        </div>
                      </div>
                      <div className='mt-4 allowedType'>
                        {formatMessage({id: 'Allowed file types: png, jpg, jpeg.'})}
                      </div>
                    </div>
                    <FileUpload
                      fileSize={2097152}
                      maxFileNumber={1}
                      allowType={['image/*', '.jpg', '.jpeg', '.png']}
                      metaData={{module: 'profileimg', isProtected: false}}
                      modalStatus={modelStatus}
                      handleClose={handleClose}
                      handleSuccess={(id: number, name: string) => {
                        setImgName(name)
                        formik.setFieldValue('fileId', id)
                      }}
                      resourceType='all'
                    />
                    <div className='col-md-7 col-12 mt-md-0 mt-6'>
                      <TextInput
                        fieldType={'text'}
                        label={formatMessage({id: 'Name'})}
                        fieldName={'name'}
                        formik={formik}
                        placeholder={formatMessage({id: 'Enter Name'})}
                        toolTipText={formatMessage({
                          id: 'GLOBAL.TOOLTIP.ADD_BOARD_ADVISORS_MODAL.NAME',
                        })}
                        isStarRequired={true}
                      />
                      <TextInput
                        fieldType={'text'}
                        fieldName={'designation'}
                        formik={formik}
                        placeholder={formatMessage({id: 'Enter Designation'})}
                        label={formatMessage({id: 'Designation'})}
                        toolTipText={formatMessage({
                          id: 'GLOBAL.TOOLTIP.ADD_BOARD_ADVISORS_MODAL.DESIGNATION',
                        })}
                        isStarRequired={true}
                      />
                      <TextInput
                        fieldType={'date'}
                        label={formatMessage({id: 'Joining Date'})}
                        fieldName={'joining_month'}
                        formik={formik}
                        placeholder={formatMessage({id: 'Select Date'})}
                        toolTipText={formatMessage({
                          id: 'GLOBAL.TOOLTIP.ADD_BOARD_ADVISORS_MODAL.JOINING_DATE',
                        })}
                        isStarRequired={true}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className='p-0'>
                <button
                  type='button'
                  className='btn btn-light font-size-13 font-weight-400'
                  onClick={() => {
                    setShowBoardAdvisorsModal(false)
                    setImgName('')
                  }}
                >
                  {formatMessage({id: 'Cancel'})}
                </button>
                <CustomButton
                  isSubmitting={formik.isSubmitting}
                  isValid={formik.isValid}
                  buttonText={formatMessage({
                    id: updateModalStatus
                      ? memberType === membersType.ADVISOR
                        ? 'Edit Advisor'
                        : 'Edit Member'
                      : memberType === membersType.ADVISOR
                      ? 'Add Advisor'
                      : 'Add Member',
                  })}
                  loading={loading}
                  widthLoading={2}
                  width={2}
                  margin={'me-5 mt-5'}
                />
              </Modal.Footer>
            </Form>
          )
        }}
      </Formik>
    </Modal>
  )
}
